import React from 'react';

import WebsiteDetail from './Website';

const WebsitePage = () =>
  <div>
    <WebsiteDetail />
  </div>

export default WebsitePage;



// WEBPACK FOOTER //
// ./src/components/admin/WebsitePage.jsx